<template>
  <div class="container hiddesScroll">
    <b-row class="cardLaranja2">
      <b-col cols="12" md="4" class="text-center tableImg ">
        <span @click="detailsImage('image17')">
          <img src="@/assets/img/page/image17.png" alt="Imagem app 16" width="120%" class="img-fluid-top">
        </span>
      </b-col>

      <b-col cols="12" md="4" lg="5" class="alinhaCentro text-center margin-button">
        <h1 class="tamanhoFonte"><b>Crie sua loja</b></h1>
        <h1 class="tamanhoFonte"><b>virtual e seu aplicativo</b></h1>
        <h1 class="tamanhoFonte"><b>em até 24 horas</b></h1>
      </b-col>

      <b-col cols="12" md="4" lg="3" class="text-center margin-note-phone">
        <span @click="detailsImage('image16')">
          <img src="@/assets/img/page/image16.png" alt="Imagem app 17" class="imgTitleInitial">
        </span>
      </b-col>
    </b-row>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <b-button variant="success" block size="lg" class="btn-demonstracao" @click="chamarWhatsapp()">Falar com especialista</b-button>
      </div>
      
      <div class="col-12 text-center mt-4 mb-4">
        <iframe 
          class="videoYoutube"
          width="750" 
          height="350" 
          src="https://www.youtube.com/embed/Iehz5WvPQPc?si=vcQPGxzM7iUI_Xde" 
          title="YouTube video player"
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          allowfullscreen
        >
        </iframe>
      </div>

      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Um aplicativo de vendas completo para seus clientes comprarem</h1>
        <h1 class="titleH1">da sua loja em qualquer lugar e horário</h1>
      </div>
    </div>

    <div class="row mt-4 mb-4">
      <div class="col-4 text-center">
        <span @click="detailsImage('image2')">
          <img src="@/assets/img/page/image2.png" alt="Imagem app 1" width="100%">
        </span>
      </div>

      <div class="col-4">
        <span @click="detailsImage('image3')">
          <img src="@/assets/img/page/image3.png" alt="Imagem app 2" width="100%">
        </span>
      </div>

      <div class="col-4">
        <span @click="detailsImage('image4')">
          <img src="@/assets/img/page/image4.png" alt="Imagem app 3" width="100%">
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Um <span class="c-orange">site</span> de vendas completo para seus clientes comprarem da sua loja</h1>
        <h1 class="titleH1">em qualquer lugar e horário</h1>
      </div>
    </div>

    <div class="row text-center mb-4 mt-4">
      <div class="col-12 mb-4">
         <span @click="detailsImage('image5')">
          <img src="@/assets/img/page/image5.png" alt="Imagem app 5" width="100%">
        </span>
      </div>

      <div class="col-12 col-sm-12 col-md-6	col-lg-6 col-xl-6">
         <span @click="detailsImage('image6')">
          <img src="@/assets/img/page/image6.png" alt="Imagem app 6" width="100%">
        </span>
      </div>

      <div class="col-12 col-sm-12 col-md-6	col-lg-6 col-xl-6">
         <span @click="detailsImage('image7')">
          <img src="@/assets/img/page/image7.png" alt="Imagem app 7" width="100%">
        </span>
      </div>
    </div>

    
    <div class="row mt-4 mb-4">
      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Benefícios para sua empresa</h1>
      </div>

      <div class="col-6">
        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Ganhe mais um canal de vendas
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Vendas anúncios dentro da sua loja virtual
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Venda em qualquer dia e horário
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Customize quando quiser sua loja virtual
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Facilidade para criar sua loja virtual
        </p>
      </div>

      <div class="col-6">
        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Comunique-se direto com seu cliente 
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Receba direto na sua conta digital
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Fortaleça sua marca
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Se destaque da sua concorrência
        </p>

        <p class="mb-4">
          <span class="checkList"><i class="fas fa-check"></i></span>
          Mais de 500 mil itens já cadastrados
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <b-button variant="success" block size="lg" class="btn-demonstracao" @click="chamarWhatsapp()">Falar com especialista</b-button>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Veja como é rápido montar e personalizar sua loja virtual</h1>
        <h1 class="titleH1">em 3 minutos</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <iframe 
          class="videoYoutube"
          width="750" 
          height="350" 
          src="https://www.youtube.com/embed/Sc54VwMja_U?si=F_zwDFex7_6q8D0t" 
          title="YouTube video player"
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          allowfullscreen
        >
        </iframe>
      </div>
    </div>

    <div class="row mt-4 mb-4">
      <div class="col-6">
        <ul class="listUl">
          <li class="cardItensLinst">Personalize as <span class="c-orange">cores</span> da sua loja virtual</li>
          <li class="cardItensLinst">Inclua sua <span class="c-orange">logo marca</span></li>
          <li class="cardItensLinst">Facilidade para incluir seus produtos, já que contamos com mais de<span class="c-orange"> 500.000 produtos </span></li>
        </ul>
      </div>

      <div class="col-6">
        <ul class="listUl">
          <li class="cardItensLinst">Personalize com<span class="c-orange"> seus banners</span></li>
          <li class="cardItensLinst">Recados, promoções, novidades, notificações <span class="c-orange">direto pela plataforma.</span></li>
          <li class="cardItensLinst">Todas as <span class="c-orange">suas redes sociais</span> na sua loja virtual.</li>
        </ul>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <div class="bg-orange c-white text-center p-5">
          <h1 class="pt-4 mb-4">Vantagens em ter seu próprio aplicativo</h1>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-4	col-lg-4 col-xl-4 mt-2">
              <img src="@/assets/img/grafico40.png" class="img-grafico img-fluid rounded imgGrafico" alt="Grafico de barras 40%">
              <h5 class="card-text mt-2">Desde o inicio da pandemia, as compras realizadas pela internet no Brasil aumentaram em 40%</h5>
            </div>
            
            <div class="col-12 col-sm-12 col-md-4	col-lg-4 col-xl-4 mt-4">
              <img src="@/assets/img/grafico76.png" class="img-grafico img-fluid rounded imgGrafico1" alt="Grafico de pizza porcentagem 76%">
              <h5 class="card-text mt-4">de todas comprar online, 76% são feitas por celulares</h5>
            </div>

            <div class="col-12 col-sm-12 col-md-4	col-lg-4 col-xl-4 mt-3">
              <img src="@/assets/img/grafico85.png" class="img-grafico img-fluid rounded imgGrafico2" alt="Grafico de pizza porcentagem 85%">
              <h5 class="card-text mt-4">85% dos brasileiros com celular compram online</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <span @click="detailsImage('image9')">
          <img src="@/assets/img/page/image9.png" alt="Imagem app 9" width="100%">
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <b-button variant="success" block size="lg" class="btn-demonstracao" @click="chamarWhatsapp()">Falar com especialista</b-button>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Não se iluda, depender exclusivamente do ponto de vendas físico</h1>
        <h1 class="titleH1">para vender mais e alcançar mais clientes não é mais uma opção</h1>
        <h1 class="titleH1">viável hoje em dia!</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <span @click="detailsImage('image10')">
          <img src="@/assets/img/page/image10.png" alt="Imagem app 10" class="tabletImg">
        </span>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Conheça algumas funcionalidades da sua loja virtual </h1>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 text-center mb-4">
        <span @click="detailsImage('image11')">
          <img src="@/assets/img/page/image11.png" alt="Imagem app 11" width="100%">
        </span>
      </div>
    </div>

    <!-- <div class="row mt-4 mb-4 cardLaranja">
      <div class="col-12 text-center">
        <h1 class="titleH1">Investimento para ter sua loja virtual</h1>
      </div>

      <div class="col-12 mt-4">
        <p>
          De acordo com o Google para criar sua loja virtual o investimento gira em torno de R$50 mil 
          reais a R$ 500 mil reais, isso sem levar em consideração o tempo para desenvolver com toda 
          tecnologia que atualmente a Constr Up te entrega.
        </p>
        <br>
        <p>
          A Constr Up cria sua loja em menos de 24 horas com planos de menos R$14,00 por dia. A pergunta é: 
        </p>
        <br>
        <p>
          O que você faz com R$14,00 reais por dia? 
        </p>
        <br>
        <p>Com a Constr Up você cria sua loja virtual e se torna visível para todo Brasil!</p>
      </div>
    </div> -->

    <div class="row mt-2">
      <div class="col-12 text-center mt-4 mb-4 cardLaranja">
        <h1 class="titleH1">Conheça nossas opções:</h1>
      </div>

      <div class="col-12 text-center mb-4">
        <h1 class="titleH1">Opção para ter o <span class="c-orange">APLICATIVO</span> de vendas da sua  loja</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12	col-lg-12 col-xl-12 text-center mb-4">
        <span @click="detailsImage('image2')">
          <img src="@/assets/img/page/image2.png" alt="Imagem app 2" width="30%" class="tableImg2">
        </span>
      </div>

      <!-- <div class="col-12 col-sm-12 col-md-8	col-lg-8 col-xl-8 text-center mb-4 tableImg">
        <span @click="detailsImage('image13')">
          <img src="@/assets/img/page/image13.png" alt="Imagem app 13" width="100%">
        </span>
      </div> -->
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <b-button variant="success" block size="lg" class="btn-demonstracao" @click="chamarWhatsapp('+sobre+o+App')">Quero só o App</b-button>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Opção para ter o <span class="c-orange">SITE</span> de vendas da sua loja</h1>
      </div>
    </div>

    <div class="row">
      <!-- <div class="col-12 col-sm-12 col-md-8	col-lg-8 col-xl-8 text-center mb-4">
        <span @click="detailsImage('image14')">
          <img src="@/assets/img/page/image14.png" alt="Imagem app 14" width="100%">
        </span>
      </div> -->

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-4 tableImg">
        <span @click="detailsImage('image6')">
          <img src="@/assets/img/page/image6.png" alt="Imagem app 6" width="100%">
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <b-button variant="success" block size="lg" class="btn-demonstracao" @click="chamarWhatsapp('+sobre+o+site')">Quero só o Site</b-button>
      </div>
    </div>
    
    <div class="row mt-2">
      <div class="col-12 text-center mt-4 mb-4">
        <h1 class="titleH1">Opção para ter o <span class="c-orange">SITE</span> e o <span class="c-orange">APLICATIVO</span> de vendas da sua  loja</h1>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-sm-12 col-md-6	col-lg-6 col-xl-6 text-center mb-4">
        <span class="recomendado">RECOMENDADO</span>
        <span @click="detailsImage('image2')">
          <img src="@/assets/img/page/image2.png" alt="Imagem app 2" width="250px">
        </span>
      </div>

      <div class="col-12 col-sm-12 col-md-6	col-lg-6 col-xl-6 text-center mb-4 tableImg">
        <span @click="detailsImage('image6')">
          <img src="@/assets/img/page/image6.png" alt="Imagem app 6" width="100%">
        </span>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-12 text-center mb-4">
        <span @click="detailsImage('image15')">
          <img src="@/assets/img/page/image15.png" alt="Imagem app 15" width="100%">
        </span>
      </div>
    </div> -->

      
    <div class="row">
      <div class="col-12 text-center mt-4 mb-4">
        <b-button variant="success" block size="lg" class="btn-demonstracao" @click="chamarWhatsapp('+sobre+o+App/Site')">Quero o App e o Site</b-button>
      </div>
    </div>
    
    <ImageModal ref="imageModal"/>
  </div>

</template>

<script>
import scrollToElement from '../mixins/scrollToElement';
import ImageModal from '@/components/LandingPage/ImageModal.vue'

export default {
 mixins:[scrollToElement],
  name: "LojaVirtualComApp",
  components: {
    ImageModal,
  },
  
  created(){
    this.scrollToElement();
  },
  mounted() {
   this.scrollToElement();
  },

  methods: {
    detailsImage(url) {
      this.$refs.imageModal.toggleOpen({ linkImg: url })
    },

    solicitarApp(id=null) {
      if(id == null) {
        this.$router.push({ name: 'cadastro-demo-lojista'});
      } else {
        this.$router.push({ name: 'cadastro-lojista', query:{'novoApp': 'solicitar-app', plano: id}});
      }
    },
    chamarWhatsapp(complement = '') {
      const url = `https://wa.me/5519992065613?text=Quero+falar+com+um+especialista ${complement}`;
      window.open(url, "_blank");
    }
  },
};
</script>

<style scoped>
.img-fluid-top {
  max-width: 120%;
  height: auto;
}
.imgTitleInitial {
  max-width: 200px;
}
.titleH1 {
  margin-bottom: 0;
  line-height: 1;
  font-weight: bold;
  font-size: 38px;
}
.btn-demonstracao {
  font-size: 28px;
  font-weight: bold;
  height: 3.5em;
  border-radius: 20px;
}

.tamanhoFonte {
  font-size: 50px;
}
.checkList {
  background-color: #4bae4f;
  color: #FFF;
  padding: 5px 10px;
  border-radius: 50px;
}
.listUl {
  font-size: 1.2rem;
}
.tabletImg {
  max-width: 400px;
}
.tableImg {
  justify-content: center;
  align-items: center;
  display: flex;
}
.recomendado {
  background-color: #00ff00;
  color: #222;
  position: absolute;
  left: 50px;
  padding: 3px 20px;
  transform: rotate(-25deg);
}

.cardLaranja {
  background-color: #FF7F00;
  color: #FFF;
  padding: 60px 80px;
  font-weight: 300 !important;
  font-family: Roboto;
}

.cardLaranja2 {
  background-color: #FF7F00;
  color: #FFF;
  font-weight: 300 !important;
  font-family: Roboto;
  padding-bottom: -30px;
}
.alinhaCentro {
  position: relative;
  margin: auto;
  padding-left: 5%;
}
@media screen and (max-width: 600px) {
.img-fluid-top {
  max-width: 100%;
  height: auto;
}
.tamanhoFonte {
  font-size: 2rem;
}
.imgTitleInitial {
  margin-bottom: 50px;
}
.titleH1 {
  font-size: 22px;
}
.cardLaranja {
  padding: 60px 20px;
}
.imgGrafico {
  margin-left: 5%;
}
.imgGrafico1 {
  margin-left: -25%;
}
.imgGrafico2 {
  margin-left: -10%;
}
.checkList {
  background-color: #4bae4f;
  color: #FFF;
  padding: 0 4px;
  border-radius: 50px;
}
.listUl {
  font-size: 1.2rem;
}
.tabletImg {
  max-width: 250px;
}
.tableImg2 {
  width: 70%;
}
.videoYoutube {
  width: 95% !important;
}
.tableImg {
  justify-content: center;
  align-items: center;
  display: flex;
}
.recomendado {
  left: 32%;
  top: -20px;
  padding: 3px 20px;
  transform: rotate(0deg);
}
.alinhaCentro {
  text-align: center;
  padding-left: 0;
}
.cardItensLinst {
  margin-top: 15px;
}

.margin-note-phone {
  margin-top: -90px;
}
.margin-button {
  margin-bottom: 100px;
  z-index: 10;
}
.hiddesScroll {
  overflow-x: hidden;
}
}
</style>
